import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useSession } from '@/lib/auth'
import SessionUnknown from '@/components/auth/SessionUnknown'

export default function RequireAuth() {
  const session = useSession()
  const location = useLocation()

  const user = session.data
  // Na /login wolno odesłać wyłącznie po 401 (data === null). Brak odpowiedzi
  // przy pierwszym pytaniu to ekran „brak połączenia", nie wylogowanie.
  if (user === undefined) return <SessionUnknown />
  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (user.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />
  }

  // Nieudany refetch przy znanym użytkowniku nie wyrzuca z aplikacji — dane
  // sesji zostają, a ekrany zależne od serwera same pilnują świeżości.
  return <Outlet />
}
